import { createSlice } from '@reduxjs/toolkit';
import { strictEqual } from 'assert';
import { Controls } from 'react-flow-renderer';

export const socialCommunity = createSlice({
  name: 'socialCommunity',
  initialState: {
    //community
    posts: [],
    topAmbasdor: [],
    leaderboardSetting: {},
    groups: [],
    badges: [],
    points: [],
    activeCourseAssets: [],
    rewardSetting: {},
    groupDetails: {},
    community: {},
    communityOwner: {},
    communityMembers: [],
    totalMembersCount: 0,
    isMembersDataLoading: false,
    communityGroups: [],
    contactPosts: [],
    communityAllMembers: [],
    groupMembers: [],
    members: [],
    notifications: [],
    events: {
      eventList: [],
      totalCount: 0
    },
    courses: [],
    products: [],
    userPoint: {},
    tournaments: [],
    memberships: [],
    recentNews: [],
    upcomingEvents: {},
    //profile
    profile: {},
    profileRanks: [],
    profileArchievements: [],
    profileCourses: [],
    profileCoursesHomepage: [],
    profileCoursesLessons: [],
    courseQuizResults: [],
    courseVideoPlayerActivity: {},
    profileContracts: [],
    profileTasks: [],
    profileEvents: [],
    profileOrders: [],
    profileFiles: [],
    profilePosts: [],
    profileGroups: [],
    profileFollowing: [],
    profileFollowers: [],
    familyMembers: [],
    sharedGoal: [],
    profileTotals: {
      followers: 0,
      following: 0,
      courses: 0
    },
    selectedGoal: {},
    subGoalsList: [],
    topMembers: [],
    dmChats: [],
    ownerChats: [],
    groupChatHistory: [],
    contactChats: [],
    taskColumns:[],
    isOpenChat: false,
    isOpenBubbleChat: false,
    isShowBubble: false,
    isOpenDmChat: false,
    isOpenDmBubbleChat: false,
    isShowDmBubble: false,
    memberDetails: {},
    selectedContact: {},
  },
  reducers: {
    setCommunityReducer: (state, action) => {
      state.community = action?.payload;
    },
    setCommunityOwnerReducer: (state, action) => {
      state.communityOwner = action?.payload;
    },
    setRecentNewsReducer: (state, action) => {
      state.recentNews = action?.payload;
    },
    setCommunityBadgesReducer: (state, action) => {
      state.badges = action?.payload;
    },
    setCommunityPointsReducer: (state, action) => {
      state.points = action?.payload;
    },
    setCommunityChatListReducer: (state, action) => {
      state.dmChats = action?.payload;
    },
    setCommunityOwnerChatListReducer: (state, action) => {
      state.ownerChats = action?.payload;
    },
    setCommunityContactChatsReducer: (state, action) => {
      state.contactChats = action?.payload;
    },
    setCommunityRewardSettingReducer: (state, action) => {
      state.rewardSetting = action?.payload;
    },
    setUpcommingEventsReducer: (state, action) => {
      state.upcomingEvents = action?.payload;
    },
    setMembersReducer: (state, action) => {
      state.members = action?.payload;
    },
    setToggleMembersDataLoading: (state, action) => {
      state.isMembersDataLoading = !state.isMembersDataLoading;
    },
    setGroupsReducer: (state, action) => {
      state.groups = action?.payload;
    },
    setCommunityContactPostsReducer: (state, action) => {
      state.contactPosts = action?.payload;
    },
    resetCommunityPostsReducer: (state, action) => {
      state.posts = action?.payload;
    },
    //Community live chat members

    setCommunityMembersReducer: (state, action) => {
      state.communityMembers = action?.payload;
    },
    setMembersTotalCountReducer: (state, action) => {
      state.totalMembersCount = action?.payload;
    },
    setLiveChatHistoryReducer: (state, action) => {
      state.livechatHistory = action?.payload;
    },
    setStarLiveChatHistoryReducer: (state, action) => {
      state.starLiveChatHistory = action?.payload;
    },
    setUnseenLiveChatHistoryReducer: (state, action) => {
      state.unseenLiveChatHistory = action?.payload;
    },
    setGroupChatHistoryReducer: (state, action) => {
      state.groupChatHistory = action?.payload;
    },
    setTotalMembersReducer: (state, action) => {
      state.totalMembers = action?.payload;
    },
    setPostsReducer: (state, action) => {
      const postMap = new Map(state.posts.map((post) => [post._id, post]));
      action.payload.forEach((newPost) => {
        // Check if the new post's _id matches an existing post
        if (postMap.has(newPost._id)) {
          // If matched, update the existing post with the newer one
          const existingPostIndex = state.posts.findIndex((post) => post._id === newPost._id);
          if (existingPostIndex !== -1) {
            state.posts[existingPostIndex] = newPost;
          }
        } else {
          state.posts.push(newPost);
        }
      });
      state.posts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    resetPostWithNewPosts: (state, action) => {
      state.posts = action?.payload;
    },
    setgroupDetailsReducer: (state, action) => {
      state.groupDetails = action?.payload;
    },
    setGroupMembersReducer: (state, action) => {
      state.groupMembers = action?.payload;
    },
    setNotificationsReducer: (state, action) => {
      state.notifications = action?.payload;
    },
    //shop
    setEventsReducer: (state, action) => {
      state.events = action?.payload;
    },
    setCoursesReducer: (state, action) => {
      state.courses = action?.payload;
    },
    setProductsReducer: (state, action) => {
      state.products = action?.payload;
    },
    setTournamentsReducer: (state, action) => {
      state.tournaments = action?.payload;
    },
    setMembershipsReducer: (state, action) => {
      state.memberships = action?.payload;
    },
    //profile
    setProfileRankReducer: (state, action) => {
      state.profileRanks = action?.payload;
    },
    setFamilyMembersReducer: (state, action) => {
      state.familyMembers = action?.payload;
    },
    setProfileArchievementReducer: (state, action) => {
      state.profileArchievements = action?.payload;
    },
    setProfileCoursesReducer: (state, action) => {
      state.profileCourses = action?.payload;
    },
    setProfileCoursesReducerHomepage: (state, action) => {
      state.profileCoursesHomepage = action?.payload;
    },
    setProfileCoursesLessonReducer: (state, action) => {
      state.profileCoursesLessons = action?.payload;
    },
    setProfileContractsReducer: (state, action) => {
      state.profileContracts = action?.payload;
    },
    setProfileTasksReducer: (state, action) => {
      state.profileTasks = action?.payload;
    },
    setProfileEventsReducer: (state, action) => {
      state.profileEvents = action?.payload;
    },
    setProfileOrdersReducer: (state, action) => {
      state.profileOrders = action?.payload;
    },
    setProfileFilesReducer: (state, action) => {
      state.profileFiles = action?.payload;
    },
    setProfileReducer: (state, action) => {
      state.profile = action?.payload;
    },
    setProfilePostsReducer: (state, action) => {
      state.profilePosts = action?.payload;
    },
    setProfileGroupsReducer: (state, action) => {
      state.profileGroups = action?.payload;
    },
    setProfileFollowingReducer: (state, action) => {
      state.profileFollowing = action?.payload;
    },
    setProfileFollowersReducer: (state, action) => {
      state.profileFollowers = action?.payload;
    },
    // course quiz results
    courseQuizResultsReducer: (state, action) => {
      state.courseQuizResults = action?.payload;
    },
    courseVideoPlayerActivityReducer: (state, action) => {
      state.courseVideoPlayerActivity = action?.payload;
    },
    sharedGoalReducer: (state, action) => {
      state.sharedGoal = action?.payload;
    },
    selectGoal: (state, action) => {
      state.selectedGoal = action?.payload;
    },
    fetchSubGoals: (state, action) => {
      state.subGoalsList = action?.payload;
    },
    getPointReducer: (state, action) => {
      state.userPoint = action?.payload;
    },
    getTopMemberReduce: (state, action) => {
      state.topMembers = action?.payload;
    },
    getTopAmbasdorReducer: (state, action) => {
      state.topAmbasdor = action?.payload;
    },
    leaderboardSettingReducer: (state, action) => {
      state.leaderboardSetting = action?.payload;
    },
    setActiveCourseAssets: (state, action) => {
      state.activeCourseAssets = action?.payload;
    },
    setTaskColumnsReducer: (state, action) => {
      state.taskColumns = action?.payload;
    },
    setIsOpenChatReducer: (state, action)=> {
      state.isOpenChat = action?.payload
    },
    setIsOpenBUbbleChatReducer: (state, action)=> {
      state.isOpenBubbleChat = action?.payload
    },
    setIsShowBubbleReducer: (state, action)=> {
      state.isShowBubble = action?.payload
    },
    setIsOpenDmChatReducer: (state, action)=> {
      state.isOpenDmChat = action?.payload
    },
    setIsOpenBUbbleDmChatReducer: (state, action)=> {
      state.isOpenDmBubbleChat = action?.payload
    },
    setIsShowDmBubbleReducer: (state, action)=> {
      state.isShowDmBubble = action?.payload
    },
    setMemberDetailsReducer: (state, action) => {
      state.memberDetails = action?.payload;
    },
    setSelectedContactReducer: (state, action) => {
      state.selectedContact = action?.payload;
    }
  }
});
export const {
  setCommunityReducer,
  setActiveCourseAssets,
  resetPostWithNewPosts,
  setCommunityOwnerReducer,
  leaderboardSettingReducer,
  setMembersReducer,
  setToggleMembersDataLoading,
  setTotalMembersReducer,
  setCommunityBadgesReducer,
  setCommunityPointsReducer,
  setCommunityRewardSettingReducer,
  setPostsReducer,
  setGroupsReducer,
  activateLiveChatHistoryLoadingReducer,
  deactivateLiveChatHistoryLoadingReducer,
  //
  // setLiveChatHistoryReducer,
  // setStarLiveChatHistoryReducer,
  // setUnseenLiveChatHistoryReducer,
  setGroupChatHistoryReducer,
  // setStarMembersReducer,
  setCommunityMembersReducer,
  setMembersTotalCountReducer,
  //
  setgroupDetailsReducer,
  setGroupMembersReducer,
  setNotificationsReducer,
  setEventsReducer,
  setCoursesReducer,
  setProductsReducer,
  setTournamentsReducer,
  setMembershipsReducer,
  setProfileRankReducer,
  setProfileArchievementReducer,
  setProfileCoursesReducer,
  setProfileContractsReducer,
  setProfileTasksReducer,
  sharedGoalReducer,
  setProfileEventsReducer,
  setProfileOrdersReducer,
  setProfileFilesReducer,
  setProfileReducer,
  setProfilePostsReducer,
  setProfileGroupsReducer,
  setProfileFollowingReducer,
  setProfileFollowersReducer,
  setProfileCoursesLessonReducer,
  setFamilyMembersReducer,
  setRecentNewsReducer,
  setUpcommingEventsReducer,
  courseQuizResultsReducer,
  setProfileCoursesReducerHomepage,
  courseVideoPlayerActivityReducer,
  selectGoal,
  fetchSubGoals,
  userPoint,
  getPointReducer,
  getTopMemberReduce,
  getTopAmbasdorReducer,
  setCommunityChatListReducer,
  setCommunityOwnerChatListReducer,
  setCommunityContactChatsReducer,
  setTaskColumnsReducer,
  setIsOpenChatReducer,
  setIsOpenBUbbleChatReducer,
  setIsShowBubbleReducer,
  setIsOpenDmChatReducer,
  setIsOpenBUbbleDmChatReducer,
  setIsShowDmBubbleReducer,
  setMemberDetailsReducer,
  setSelectedContactReducer
} = socialCommunity.actions;

export default socialCommunity.reducer;
